const hasMobileUserAgent = (navigator = window.navigator || { userAgent: '' }) =>
  /CarvanaNativeWebView/gi.test(navigator.userAgent);

const iPhoneRegex = new RegExp(
  'CarvanaNativeWebView/(?<AppVersion>\\S+) \\((?<DeviceName>[^;]+); CPU iPhone OS (?<OsVersion>\\S+)'
);

const androidRegex = new RegExp(
  'CarvanaNativeWebView/(?<AppVersion>\\S+) \\(Linux; Android (?<OsVersion>[^;]+); (?<DeviceName>[^;]+); wv'
);

const mobileVersion = ({ userAgent } = window.navigator || { userAgent: '' }) => {
  if (!/CarvanaNativeWebView/gi.test(userAgent)) {
    return null;
  }
  const iPhone = /iPhone/.test(userAgent);
  const regex = iPhone ? iPhoneRegex : androidRegex;
  const matches = regex.exec(userAgent);
  return {
    appVersion: matches?.groups?.AppVersion || 'Unknown',
    osVersion: matches?.groups?.OsVersion || 'Unknown',
    deviceName: matches?.groups?.DeviceName || 'Unknown',
    appType: iPhone ? 'iPhone' : 'Android',
    matched: matches != null,
    userAgent
  };
};

export { hasMobileUserAgent, mobileVersion };
